
import Vue from 'vue';
import axios from 'axios';
interface Product {
  name: string;
  id: string;
  selected: boolean;
}

import TextInput from '@shared/components/TextInput.vue';
import CheckboxInput from '@shared/components/CheckboxInput.vue';

export default Vue.extend({
  name: 'NewCustomerForm',
  components: {
    TextInput,
    CheckboxInput,
  },
  data() {
    return {
      inquiry: process.env.VUE_APP_INQUIRY as string,
      page: '1',
      errors: [''],

      consent: false,

      userInfo: {
        name: '',
        email: '',
        phone: '',
        birthDate: '',
        zip: '',
        address: '',
      },
      products: [
        {
          name: 'Strøm',
          id: process.env.VUE_APP_PRODUCT_STROM,
          selected: false,
        },
        {
          name: 'Internett/TV',
          id: process.env.VUE_APP_PRODUCT_INTERNETTTV,
          selected: false,
        },
      ] as Product[],
    };
  },
  methods: {
    setPage(id: string): void {
      this.page = id;
    },
    save(e: Event): void {
      if (!this.checkForm(e)) {
        return;
      }

      const http = axios.create({
        baseURL: process.env.VUE_APP_BACKEND_URL,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      const selectedProducts = this.products.filter(
        (p: Product) => p.selected === true
      );

      const postData = { description: '' } as any;
      postData.name = this.userInfo.name;
      postData.phone = this.userInfo.phone;
      postData.email = this.userInfo.email;
      postData.subject = `Ny kunde: ${this.userInfo.name} ønsker`;
      postData.description += `Ny Kunde \n\nBli kunde - velg produkter \nØnskede Tjenester \n\n`;

      selectedProducts.forEach((product: Product) => {
        postData[product.id] = 1;
        postData.subject += ' ' + product.name;
        postData.description += product.name + '\n';
      });

      postData.subject += ' (innmeldt på hkraft.no)';
      postData.description += '\nBli kunde - din kontaktinfo\n';
      postData.description += `Navn: ${this.userInfo.name} \nFødselsdato: ${this.userInfo.birthDate} \nBosted: ${this.userInfo.address} \n`;
      postData.description += `Postnummer: ${this.userInfo.zip} \nEmail: ${this.userInfo.email} \nTelefon: ${this.userInfo.phone} \n`;
      postData.description +=
        '\nJeg samtykker til at Haugaland Kraft lagrer og bruker denne informasjonen til å følge opp henvendelsen.';

      postData[this.inquiry] = 'Ny kunde / bestille';

      let pd = '';
      Object.keys(postData).forEach((key) => {
        if (pd.length > 1) {
          pd += '&';
        }
        pd += `${key}=${encodeURI(postData[key])}`;
      });

      // @ts-ignore
      this.$gtm.trackEvent({
        event: 'new_customer_form_private',
        category: 'Bli kunde',
        action: 'Fullført skjema',
        label: selectedProducts.map((x) => x.name).join(', '),
      });
      http
        .post('', pd)
        .then()
        .catch((err) => console.log('err', err));
      this.setPage('3');
    },
    checkForm(e: Event): boolean {
      this.errors = [];

      if (!this.userInfo.name) {
        this.errors.push('Mangler navn.');
      }
      if (!this.userInfo.email) {
        this.errors.push('Mangler epost');
      }
      if (!this.userInfo.address) {
        this.errors.push('Mangler adresse');
      }

      if (!this.errors.length) {
        return true;
      }
      e.preventDefault();
      return false;
    },
  },
  computed: {
    isAProductSelected(): boolean {
      return this.products.some((p: Product) => p.selected === true);
    },
  },
});
